<template>
  <v-container>
    <v-spacer/>
    <v-row v-if="!passwordResetSubmitted">
      <v-col cols="8" offset="2">
        <v-form ref="form" class="mt-5 py-3" @submit.prevent="submitPasswordReset">
          <v-text-field
              v-model="email"
              :rules="[rules.required, rules.email]"
              hide-details="auto"
              label="Email"
          ></v-text-field>
          <v-spacer/>
          <v-btn block class="mt-5 " type="submit">
            Request Password Reset
          </v-btn>
        </v-form>
      </v-col>
    </v-row>
    <div v-else class="text-center">
      <h1>Password Reset Submitted</h1>
      <p>You will receive an email momentarily to complete your password reset.</p>
    </div>
  </v-container>
</template>

<script>

import rules from '../helpers/forms'

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      passwordResetSubmitted: false,
      rules: rules
    }
  },
  methods: {
    submitPasswordReset() {
      var valid = this.$refs.form.validate()
      if (valid) {
        this.$store.dispatch('postPasswordReset', {email: this.email})
            .then(response => {
              this.passwordResetSubmitted = true
            })
      }
    }
  }
}
</script>

<style>
</style>
